import { SELF_PATH, SELF_STATISTICS } from '../../constants/globalConstants'
import { instance } from '../../utils/coreAPI'

export const getSelfUser = async () => {
  try {
    const response = await instance.get(SELF_PATH)
    return response.data
  } catch (error: any) {
    return await Promise.reject(error)
  }
}

export const getSelfStatistic = async () => {
  try {
    const response = await instance.get(SELF_STATISTICS)
    return response.data
  } catch (error: any) {
    return await Promise.reject(error)
  }
}
